import { ErrorBaseData } from '.'

export const attendanceFormErrors: Record<string, ErrorBaseData> = {
  AttendanceFormNotFoundException: {
    message: 'Formulário de atentimento não encontrado',
    description: 'Não foi possível encontrar o formulário de atendimento. Verifique as informações e tente novamente',
  },
  AttendanceFormQuestionNotFoundException: {
    message: 'Pergunta do formulário não encontrada',
    description:
      'Não foi possível encontrar a pergunta do formulário de atendimento. Verifique as informações e tente novamente',
  },
  AttendanceFormUneditableException: {
    message: 'Formulário de atentimento não editável',
    description: 'Este formulário de atendimento não pode mais ser editado',
  },
}
